<div id="dvNCESLogoCover" class="card card-body h-100" style="padding:0px;">
	<!-- desktop views -->
	<div *ngIf="!showMinimize" style="height:100%;">
		<div class="row" style="height:100%;">
			<div class="col-4" style="height:100%; display:flex; justify-content:center; position:relative;">
				<div style="height:80%; align-self: center;">
					<img *ngIf="!changingImage" class="splashImg" appImgCheck [defaultImage]="defaultSplash" [src]="splash" (click)="editImage($event, 'splash')" (mouseover)="editMode($event,'splash',true)" (mouseleave)="editMode($event,'splash',false)" />
					<div *ngIf="splashConfigOpen" style="pointer-events: none">
						<span class="w-100 text-center fa fa-camera camera"></span>
					</div>

					<div style="left:50%; top:50%; transform: translate(-50%, -50%); position:absolute; width:30%; height:auto;">
						<img *ngIf="!changingImage" class="logoImg" appImgCheck [defaultImage]="defaultLogo" [src]="logo" (click)="editImage($event, 'logo')" (mouseover)="editMode($event,'logo',true)" (mouseleave)="editMode($event,'logo',false)" />
						<div *ngIf="logoConfigOpen" style="pointer-events: none">
							<span class="w-100 text-center fa fa-camera camera"></span>
						</div>
					</div>
				</div>
			</div>

			<div class="col-8" style="height:100%;">
				<table style="margin: 3%; height: 80%; width: 95%;">
					<colgroup><col style="width:50%" /><col style="width:2%" /><col style="width:48%" /></colgroup>
					<tr style="vertical-align:top;">
						<td>
							<div class="jmPageTitle" style="font-weight:bold;">Welcome to {{name}} career exploration dashboard!</div>
							<div style="font-weight:normal; margin-top:10px;">
								{{city}}, {{state}} {{zipCode}}
							</div>
						</td>
						<td style="border-left:solid 2px #ccc;"></td>
						<td class="jmWidgetRoundCorners" style="height:100%;">
							<app-google-map *ngIf="location" [mapOnly]="mapOnly" [title]="schoolName" [loc]="location"></app-google-map>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>

	<!-- Mobile view" -->
	<div *ngIf="showMinimize">
		<div *ngIf="toggled" style="height: 55px; overflow:hidden;">
			<img class="splashImg" appImgCheck [defaultImage]="defaultSplash" [src]="splash" />
			<div style="top:0%; position:absolute; min-height:0; z-index:10; width:100%;">
				<div class="jmCollapseTitleLearnMore row" style="position: relative;">
					<div class="col-2" style=""><img appImgCheck [defaultImage]="defaultLogo" [src]="logo" class="jmCollapsedProfilePicture" /></div>
					<div class="col-8">
						<div class="jmPageTitle" style="line-height: 55px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">&nbsp;</div>
					</div>
					<div class="col-2">
						<span (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square" style="margin-top:15px;" role="button"></span>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="!toggled">
			<div (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square" style="padding: 20px;" role="button"></div>
			<div class="text-center w-100" style="height:150px; overflow:hidden;">
				<img *ngIf="!changingImage" class="splashImg" appImgCheck [defaultImage]="defaultSplash" [src]="splash" [ngStyle]="{'cursor':isEditor()?'pointer':'default'}" (click)="editImage($event, 'splash')" (mouseover)="editMode($event,'splash',true)" (mouseleave)="editMode($event,'splash',false)" />
				<div *ngIf="splashConfigOpen" style="pointer-events: none">
					<div class="splashShadow" style="height:150px;"></div>
					<span class="w-100 text-center fa fa-camera camera"></span>
				</div>
			</div>
			<div class="jmImgIconWidgetPositionMobile">
				<!-- Image row -->
				<div class="row">
					<div class="offset-sm-5 col-sm-2 offset-4 col-4">
						<img *ngIf="!changingImage" appImgCheck [defaultImage]="defaultLogo" [src]="logo" [ngStyle]="{'cursor':isEditor()?'pointer':'default'}" class="logoImg" (click)="editImage($event, 'logo')" (mouseover)="editMode($event,'logo',true)" (mouseleave)="editMode($event,'logo',false)" />
						<div *ngIf="logoConfigOpen" style="pointer-events: none">
							<div class="logoShadow"></div>
							<span class="w-100 text-center fa fa-camera camera"></span>
						</div>
					</div>
				</div>
				<div style="text-align:center; width:100%; margin-bottom:20px;">
					<div class="jmPageTitle" style="font-weight:bold;">Welcome to {{name}} career exploration dashboard!</div>
					<div style="font-weight:normal; margin-top:10px;">
						{{city}}, {{state}} {{zipCode}}
					</div>
				</div>
				<div style="text-align: center; width: 100%; margin-bottom: 20px; height: 200px;">
					<app-google-map *ngIf="location" [mapOnly]="mapOnly" [title]="schoolName" [loc]="location"></app-google-map>
				</div>
			</div>
		</div>
	</div>
</div>

